import React from 'react'
import './portfolio.css'
import ImageWithLoading from '../ImageWithLoading'
import IMG0 from '../../assets/botelity.jpg'
import IMG1 from '../../assets/ios-nrf52832-ls.png'
import IMG2 from '../../assets/food-fighters.png'
import IMG3 from '../../assets/rogue.png'
import IMG4 from '../../assets/garmin-marq2-golfer.png'

const data = [
    {
        id: 0,
        image: IMG0,
        title: 'Botelity',
        github: 'https://chromewebstore.google.com/detail/botelity/hkekobjnohonjofhhhpdcjnhjebdjmid'
    },
    {
        id: 1,
        image: IMG1,
        title: 'iOS App for Adafruit Feather NRF52832',
        github: 'https://www.instructables.com/IOS-App-for-Adafruit-Feather-NRF52832/'
    },
    {
        id: 2,
        image: IMG2,
        title: 'Food Fighters',
        github: 'https://github.com/akiofujita/Food-Fighters'
    },
    {
        id: 3,
        image: IMG3,
        title: 'Rogue Game',
        github: 'https://github.com/akiofujita/ece39595project'
    },
    {
        id: 4,
        image: IMG4,
        title: 'Garmin - Outdoor Smartwatches',
        github: 'https://www.garmin.com/en-US/p/783465/pn/010-02648-20'
    }
]

const Portfolio = () => {
    return (
        <section id='portfolio'>
            <h5>My Recent Work</h5>
            <h2>Portfolio</h2>

            <div className="container portfolio__container">
                {
                    data.map(({id, image, title, github}) => {
                        return (
                            <article key={id} className='portfolio__item'>
                                <div className='portfolio__item-image'>
                                    <ImageWithLoading 
                                        src={image} 
                                        alt={title}
                                        className="portfolio-image"
                                    />
                                </div>
                                <h3>{title}</h3>
                                <div className="portfolio__item-cta">
                                    <a href={github} className='btn' target='_blank' rel="noreferrer">Link</a>
                                </div>
                            </article>
                        )
                    })
                }
            </div>
        </section>
    )
}

export default Portfolio
